import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { OnboardingContainer } from '../../screens/onboarding/OnboardingContainer'
import type { OnboardingData } from '../../screens/onboarding/index'

export const Route = createFileRoute('/_unauthenticated/onboarding')({
  component: Onboarding,
})

function Onboarding() {
  const navigate = useNavigate()

  const handleOnboardingComplete = (_data: OnboardingData) => {
    navigate({ to: '/dashboard' })
  }

  return (
    <div className="min-h-screen">
      <OnboardingContainer onComplete={handleOnboardingComplete} />
    </div>
  )
}
